"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImpactStory = void 0;
var create_entity_1 = require("../../utils/create-entity");
var use_open_graph_query_1 = require("../../hooks/use-open-graph-query");
var create_entity_2 = require("../../utils/create-entity");
var impact_story_card_1 = require("../../components/entities/impact-story-card");
var impact_story_details_banner_1 = require("../../components/entities/impact-story-details-banner");
var validator_1 = __importDefault(require("validator"));
var solution_details_layout_1 = require("../../components/entities/solution-details-layout");
var graphql_1 = require("../../utils/graphql");
var handleUrlBlur = function (_a) {
  return __awaiter(void 0, [_a], void 0, function (_b) {
    var _c, image, loadingState, data, openGraph, _d;
    var name = _b.name,
      value = _b.value,
      fieldState = _b.fieldState,
      onChange = _b.onChange,
      client = _b.client;
    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _c = fieldState.image, image = _c === void 0 ? {
            value: ''
          } : _c;
          if (!(!image.value && validator_1.default.isURL(value))) return [3 /*break*/, 4];
          loadingState = __assign(__assign({}, fieldState), {
            image: __assign(__assign({}, fieldState.image), {
              loadingMessage: 'Fetching',
              disabled: true
            })
          });
          onChange(loadingState);
          _e.label = 1;
        case 1:
          _e.trys.push([1, 3,, 4]);
          return [4 /*yield*/, client.query({
            query: use_open_graph_query_1.OPEN_GRAPH_QUERY,
            variables: {
              url: value
            }
          })];
        case 2:
          data = _e.sent().data;
          openGraph = data.openGraph;
          if (openGraph && openGraph.image) {
            onChange(__assign(__assign({}, fieldState), {
              image: __assign(__assign({}, fieldState.image), {
                value: openGraph.image,
                loadingMessage: '',
                disabled: false
              })
            }));
          }
          return [3 /*break*/, 4];
        case 3:
          _d = _e.sent();
          onChange(__assign(__assign({}, fieldState), {
            image: __assign(__assign({}, fieldState.image), {
              loadingMessage: '',
              disabled: false
            })
          }));
          return [3 /*break*/, 4];
        case 4:
          return [2 /*return*/];
      }
    });
  });
};
exports.ImpactStory = {
  name: 'ImpactStory',
  label: 'Solution',
  slug: 'solution',
  isPublic: true,
  useMap: true,
  usePublishStatus: true,
  usePermissions: true,
  useConversation: true,
  useConnections: true,
  useSlices: true,
  groupName: 'Participate',
  includeInSearch: true,
  useVisibility: true,
  useFollowers: true,
  useModerators: true,
  canEmbed: true,
  options: {
    benefitsLabel: 'Benefits & Features',
    impactResultsLabel: 'Outcomes & Results'
  },
  /* -------------- ROUTES -------------- */
  autoRoutes: ['list', 'details', 'create', 'update'],
  /* -------------- COMPONENTS -------------- */
  components: {
    card: impact_story_card_1.ImpactStoryCard,
    details: solution_details_layout_1.SolutionDetailsLayout,
    banner: impact_story_details_banner_1.ImpactStoryDetailsBanner
  },
  banner: {
    showDescription: false
  },
  /* -------------- DETAILS -------------- */
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      id\n      name\n      sid\n      slug\n      description { id text html }\n      image { id url thumbnails { id full { id url width height } } }\n      video\n      url\n      startDate\n      endDate\n      latitude\n      longitude\n      organisation {\n        id slug name url\n        type { id name slug }\n        location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n        logo { id url thumbnails { id full { id url width height } } }\n      }\n      organisations {\n        id slug name url\n        location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n        type { id name slug }\n        logo { id url thumbnails { id full { id url width height } } }\n      }\n      challenges { ...EntityValueFields }\n      keyIssues { id name slug }\n      location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      locations { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      stage {\n        id\n        name\n        slug\n      }\n      files { ...FileAssetValueFields }\n      contact { ...EntityValueFields }\n      targetMarket { ...EntityValueFields }\n      innovationType { ...EntityValueFields }\n      benefits { ...EntityValueFields \n        description { id text html }\n        type { ...EntityValueFields }\n      }\n      results {\n        id\n        slug\n        title\n        direction\n        description { id text html }\n        type { ...EntityValueFields }\n      }\n      sdgs { ...EntityValueFields }\n      quotes { ...EntityValueFields person { ...EntityValueFields } }"], ["\n      id\n      name\n      sid\n      slug\n      description { id text html }\n      image { id url thumbnails { id full { id url width height } } }\n      video\n      url\n      startDate\n      endDate\n      latitude\n      longitude\n      organisation {\n        id slug name url\n        type { id name slug }\n        location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n        logo { id url thumbnails { id full { id url width height } } }\n      }\n      organisations {\n        id slug name url\n        location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n        type { id name slug }\n        logo { id url thumbnails { id full { id url width height } } }\n      }\n      challenges { ...EntityValueFields }\n      keyIssues { id name slug }\n      location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      locations { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      stage {\n        id\n        name\n        slug\n      }\n      files { ...FileAssetValueFields }\n      contact { ...EntityValueFields }\n      targetMarket { ...EntityValueFields }\n      innovationType { ...EntityValueFields }\n      benefits { ...EntityValueFields \n        description { id text html }\n        type { ...EntityValueFields }\n      }\n      results {\n        id\n        slug\n        title\n        direction\n        description { id text html }\n        type { ...EntityValueFields }\n      }\n      sdgs { ...EntityValueFields }\n      quotes { ...EntityValueFields person { ...EntityValueFields } }"])))
  },
  /* -------------- FILTERS -------------- */
  filters: {
    fields: {
      challenges: {
        entityTypeName: 'Challenge'
      },
      country: {
        entityTypeName: 'Economy'
      },
      innovationType: {
        entityTypeName: 'OfferingType'
      },
      stage: {
        entityTypeName: 'MaturityStage'
      },
      resultTypes: {
        entityTypeName: 'ImpactResultType'
      },
      keyIssues: {
        entityTypeName: 'KeyIssue'
      }
    }
  },
  /* -------------- LIST -------------- */
  list: {
    applyVisibilityState: true,
    baseState: {
      filter: {
        isPublished: {
          is: true
        }
      },
      orderBy: {
        fieldName: "name",
        desc: false
      },
      limit: create_entity_1.ITEMS_PER_PAGE,
      skip: 0
    },
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      id\n      name\n      slug\n      url\n      openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n      description { id plain(truncate: { words: 45 }) }\n      challenge { id name slug }\n      organisation {\n        id\n        name\n        logo {\n          id url thumbnails { id full { id url width height } }\n        }\n      }\n      location {\n        id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand }\n      }\n      stage {\n        id\n        name\n        slug\n      }\n      image {\n        id url thumbnails { id full { id url width height } }\n      }\n    "], ["\n      id\n      name\n      slug\n      url\n      openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n      description { id plain(truncate: { words: 45 }) }\n      challenge { id name slug }\n      organisation {\n        id\n        name\n        logo {\n          id url thumbnails { id full { id url width height } }\n        }\n      }\n      location {\n        id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand }\n      }\n      stage {\n        id\n        name\n        slug\n      }\n      image {\n        id url thumbnails { id full { id url width height } }\n      }\n    "])))
  },
  /* -------------- FORM -------------- */
  form: {
    fieldsMemoize: false,
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'benefits'
    }, {
      name: 'results'
    }, {
      name: 'quotes'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }, {
      name: 'organisations'
    }, {
      name: 'places'
    }, {
      name: 'visibility'
    }],
    fields: __assign(__assign({}, create_entity_2.entityStandardFormFields), {
      url: {
        type: 'url',
        onBlur: handleUrlBlur
      },
      description: {
        type: 'description'
      },
      contact: {
        type: 'linked',
        entityTypeName: 'Person',
        label: 'Primary Contact',
        description: 'Who is the Primary Contact for this {{IMPACT_STORY}}?'
      },
      innovationType: {
        type: 'linked',
        entityTypeName: 'OfferingType'
      },
      files: {
        type: 'linkedMultiple',
        entityTypeName: 'FileAsset'
      },
      latitude: {
        type: 'float',
        maxWidth: '400px'
      },
      longitude: {
        type: 'float',
        maxWidth: '400px'
      },
      // TODO - change this to impact story type
      stage: {
        type: 'linked',
        entityTypeName: 'MaturityStage',
        label: '{{ImpactStory.label}} Pattern',
        description: 'What type of {{ImpactStory.label}} is this?'
      },
      video: {
        type: 'text',
        maxWidth: '650px'
      },
      image: {
        type: 'image'
      },
      // // ------- Results & Benefits ------->
      benefits: {
        type: 'linkedTable',
        entityTypeName: 'Benefit',
        fieldSet: 'benefits',
        description: 'What {{BENEFITS}} are achieved in this {{IMPACT_STORY}}?'
      },
      results: {
        type: 'linkedTable',
        entityTypeName: 'ImpactResult',
        fieldSet: 'results'
      },
      quotes: {
        type: 'linkedTable',
        entityTypeName: 'Quote',
        fieldSet: 'quotes',
        description: 'Are there any notable {{QUOTES}} in this {{IMPACT_STORY}} which should be highlighted?'
      },
      // ------- Organisations ------->
      organisations: {
        type: 'linked',
        fieldSet: 'organisations',
        entityTypeName: 'Organisation'
      },
      // ------- Location ------->
      locations: {
        type: 'linked',
        entityTypeName: 'Location',
        fieldSet: 'places'
      },
      // ------- Taxonomies ------->
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      targetMarket: {
        type: 'linkedMultiple',
        entityTypeName: 'TargetMarket',
        fieldSet: 'taxonomies'
      },
      sdgs: {
        type: 'linkedMultiple',
        entityTypeName: 'Sdg',
        fieldSet: 'taxonomies'
      }
    })
  }
};
var templateObject_1, templateObject_2;